// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_TAX_REGIMES,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getTaxRegimes = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('tax_regimes')
      .then(
        (response) => {
          dispatch(GET_TAX_REGIMES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/taxRegimesActions.js